import { LanguageItem } from "@alfresco/adf-core";

/**
 * Clase que contiene el estado inicial de la aplicación.
 * @class InitState
 */
export class InitState {

    languages: LanguageItem[];
    title: string;
    infoDrawerState: boolean;
    infoDrawerMetadataAspect: string;
    hideProfile: boolean;

    /**
     * Constructor de la clase `InitState`.
     * @param {LanguageItem[]} languages - Lista de idiomas disponibles.
     * @param {boolean} infoDrawerState - Estado inicial del drawer de información.
     * @param {string} infoDrawerMetadataAspect - Aspecto inicial del metadata mostrado en el drawer de información.
     */
    constructor(languages?: LanguageItem[], title?: string, infoDrawerState?: boolean, infoDrawerMetadataAspect?: string, hideProfile?: boolean) {
        this.languages =
            languages ?? [
                { key: 'es', label: 'Español' },
                { key: 'en', label: 'English' },
                //{key: 'ca', label: 'Valencià'}
            ];
        this.title = title ?? 'ALDEN';
        this.infoDrawerState = infoDrawerState ?? true;
        this.infoDrawerMetadataAspect = infoDrawerMetadataAspect ?? 'Properties';
        this.hideProfile = hideProfile ?? false;
    }

}